import { IconClose, IconTrash } from "@/assets/images/Icons";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { formatarValorEmRealBR } from "@/components/utils/Utils";
import { FormCampanhas } from "./FormCampanhas";
import { serviceAreaVendas } from "@/services/serviceAreaVendas";
import { useLayout } from "@/contexts/UseLayout";
import TemPermissao from "@/components/utils/NiveisDeAcesso";
import { ModalBase } from "@/components/ModalBase/ModalBase";
import { normalizeCampaignLinks } from "./utils";

export function ViewCampanha({ campanha, close, reload }: any) {
  const { t } = useTranslation();
  const context = useLayout();
  const links = normalizeCampaignLinks(campanha?.links);
  const statusOptions = [
    {
      value: 1,
      label: t("campaigns.status.active"),
    },
    {
      value: 2,
      label: t("campaigns.status.competition"),
    },
    {
      value: 3,
      label: t("campaigns.status.finished"),
    },
  ];
  async function deleteCampanha(id: any) {
    confirmAlert({
      title: t("campaigns.deleteConfirmation.title"),
      message: t("campaigns.deleteConfirmation.message"),
      buttons: [
        {
          label: t("campaigns.deleteConfirmation.yes"),
          onClick: async () => {
            try {
              await serviceAreaVendas.DeleteCampanhas(id);
              close();
              reload();
            } catch {
              toast.error(t("campaigns.errors.delete"));
            } finally {
            }
          },
        },
        {
          label: t("campaigns.deleteConfirmation.cancel"),
          onClick: () => {},
        },
      ],
    });
  }
  return (
    <>
      <ModalBase
        open
        onOpenChange={close}
        className="bg-white rounded-lg pr-1 py-1 max-w-3xl w-full max-h-[90vh]"
        title="View modal campanha"
      >
        <div className="w-full overflow-y-auto max-h-full relative p-6">
          <div className="flex justify-between items-center">
            <p className="text-cinza-200 text-2xl">
              {t("campaigns.view.title")}
            </p>
            <div className="flex rounded-lg overflow-hidden">
              <FormCampanhas
                campanha={campanha}
                reload={() => {
                  close();
                  reload();
                }}
              />
              {TemPermissao(context.userLogged, "campanhas", "remover") && (
                <button
                  onClick={() => {
                    deleteCampanha(campanha?.id);
                  }}
                  disabled={!campanha?.id}
                  className="p-2 bg-azul-400/20 hover:bg-azul-400 fill-azul-400 hover:fill-white duration-300 cursor-pointer disabled:cursor-not-allowed"
                  title={t("campaigns.buttons.delete")}
                >
                  <IconTrash />
                </button>
              )}
              <button
                className="p-2 bg-azul-400/20  hover:bg-azul-400 text-azul-400 hover:text-white duration-300"
                onClick={close}
                title={t("campaigns.buttons.edit")}
              >
                <IconClose />
              </button>
            </div>
          </div>

          <div className="flex flex-wrap gap-4 justify-between pt-4">
            <div className="flex flex-col gap-4 w-full max-w-md">
              <label className="text-sm text-cinza-800 flex flex-col gap-1">
                <span className="text-azul-400 text-base">
                  {t("campaigns.view.fields.campaign")}
                </span>
                <input
                  type="text"
                  className="bg-zinc-100 outline-none px-4 h-8 border-2 border-azul-300 disabled:border-0 rounded-md"
                  disabled
                  value={campanha?.nome}
                  placeholder={t("campaigns.view.placeholders.name")}
                />
              </label>
              <label className="text-sm text-cinza-800 flex flex-col gap-1">
                <span className="text-azul-400 text-base">
                  {t("campaigns.view.fields.month")}
                </span>
                <input
                  type="text"
                  className="bg-zinc-100 outline-none px-4 h-8 border-2 border-azul-300 disabled:border-0 rounded-md"
                  disabled
                  value={campanha?.mes}
                  placeholder={t("campaigns.view.placeholders.name")}
                />
              </label>
              {campanha?.ano && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.view.fields.year")}
                  </span>
                  <input
                    type="text"
                    className="bg-zinc-100 outline-none px-4 h-8 border-2 border-azul-300 disabled:border-0 rounded-md"
                    disabled
                    value={campanha?.ano}
                    placeholder={t("campaigns.view.placeholders.year")}
                  />
                </label>
              )}
              <label className="text-sm text-cinza-800 flex flex-col gap-1">
                <span className="text-azul-400 text-base">
                  {t("campaigns.view.fields.description")}
                </span>

                <div
                  className="bg-zinc-100 linkColor outline-none px-4 py-2 rounded-md"
                  dangerouslySetInnerHTML={{
                    __html:
                      campanha?.description ||
                      `<p>${t("campaigns.view.placeholders.noDescription")}</p>`,
                  }}
                />
              </label>

              {campanha?.nomeAgencia && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.view.fields.agency")}
                  </span>

                  <input
                    type="text"
                    className="bg-zinc-100 outline-none px-4 py-2 border-2 border-azul-300 disabled:border-0 rounded-md"
                    disabled
                    value={campanha?.nomeAgencia}
                    placeholder={t("campaigns.view.placeholders.name")}
                  />
                </label>
              )}
              {campanha?.nameCliente && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.view.fields.client")}
                  </span>

                  <input
                    type="text"
                    className="bg-zinc-100 outline-none px-4 py-2 border-2 border-azul-300 disabled:border-0 rounded-md"
                    disabled
                    value={campanha?.nameCliente}
                  />
                </label>
              )}
              <label className="text-sm text-cinza-800 flex flex-col gap-1">
                <span className="text-azul-400 text-base">
                  {t("campaigns.view.fields.budget")}
                </span>

                <input
                  type="text"
                  className="bg-zinc-100 outline-none px-4 py-2 border-2 border-azul-300 disabled:border-0 rounded-md"
                  disabled
                  value={formatarValorEmRealBR(campanha?.valor)}
                  placeholder={t("campaigns.view.placeholders.name")}
                />
              </label>
              <label className="text-sm text-cinza-800 flex flex-col gap-1">
                <span className="text-azul-400 text-base">
                  {t("campaigns.view.fields.status")}
                </span>

                <Select
                  options={statusOptions}
                  isDisabled
                  value={statusOptions.find(
                    (option) => option.value == campanha?.id_status,
                  )}
                  placeholder={t("campaigns.view.placeholders.selectStatus")}
                />
              </label>
              {campanha?.nameFluxo && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.view.fields.flow")}
                  </span>

                  <input
                    type="text"
                    className="bg-zinc-100 outline-none px-4 py-2 border-2 border-azul-300 disabled:border-0 rounded-md"
                    disabled
                    value={campanha?.nameFluxo}
                    placeholder={t("campaigns.view.placeholders.priority")}
                  />
                </label>
              )}
              {campanha?.cidade && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.view.fields.city")}
                  </span>
                  <input
                    type="text"
                    className="bg-zinc-100 outline-none px-4 h-8 border-2 border-azul-300 disabled:border-0 rounded-md"
                    disabled
                    value={campanha?.cidade}
                    placeholder={t("campaigns.view.placeholders.city")}
                  />
                </label>
              )}
              {links.length > 0 && (
                <label className="text-sm text-cinza-800 flex flex-col gap-1">
                  <span className="text-azul-400 text-base">
                    {t("campaigns.links.title")}
                  </span>
                  <div className="bg-zinc-100 outline-none px-4 py-2 rounded-md flex flex-col gap-2">
                    {links.map((item) => (
                      <a
                        key={`${item.link}-${item.nome}`}
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        className="text-azul-400 underline truncate"
                        title={item.link}
                      >
                        {item.nome || item.link}
                      </a>
                    ))}
                  </div>
                </label>
              )}
            </div>
          </div>
        </div>
      </ModalBase>
    </>
  );
}
